import { ResponseType } from 'axios';

import { retrieveFromLocalStorage } from './util';

export const API_HOST = process.env.REACT_APP_API_ENDPOINT;
export const DOCUMENT_API_HOST = process.env.REACT_APP_DOCUMENT_API_ENDPOINT;
export const BASE_DOCUMENT_API_HOST = process.env.REACT_APP_BASE_DOCUMENT_API_ENDPOINT;
export const SERVER_HOST = process.env.REACT_APP_HOST;

type Headers = Record<string, string>;
type Params = Record<string, string>;

export type HttpGetOptions = {
  method: 'GET';
  headers: Headers;
  params?: Params;
  responseType?: ResponseType;
};

export type HttpPostOptions<T> = {
  method: 'POST';
  data: T;
  headers: Headers;
  params?: Params;
};

export type HttpPutOptions<T> = {
  method: 'PUT';
  data: T;
  headers: Headers;
  params?: Params;
};

export type HttpDeleteOptions = {
  method: 'DELETE';
  headers: Headers;
  params?: Params;
};

const getLoggedInUserHeaders = (): Headers => ({
  Authorization: retrieveFromLocalStorage('token'),
  userExternalReference: retrieveFromLocalStorage('user'),
  'ngrok-skip-browser-warning': 'true'
});

export const getHttpGetOptions = (headers?: Headers, params?: Params, responseType?: ResponseType): HttpGetOptions => ({
  method: 'GET',
  headers: { ...getLoggedInUserHeaders(), ...headers },
  params,
  responseType
});

export const getHttpPostOptions = <T>(data: T, headers?: Headers, params?: Params): HttpPostOptions<T> => ({
  method: 'POST',
  data,
  headers: { ...getLoggedInUserHeaders(), ...headers },
  params
});

export const getHttpPutOptions = <T>(data: T, headers?: Headers, params?: Params): HttpPutOptions<T> => ({
  method: 'PUT',
  data,
  headers: { ...getLoggedInUserHeaders(), ...headers },
  params
});

export const getHttpDeleteOptions = (headers?: Headers, params?: Params): HttpDeleteOptions => ({
  method: 'DELETE',
  headers: { ...getLoggedInUserHeaders(), ...headers },
  params
});

export const getErrorMessage = (error: unknown): string => {
  if (typeof error === 'object' && error !== null) {
    const typedError = error as { response?: { data: { message?: string; error?: string } }; message?: string };
    if (typedError.response?.data.message) return typedError.response.data.message;
    if (typedError.response?.data.error) return typedError.response.data.error;
    if (typedError.message) return typedError.message;
  }

  if (typeof error === 'string') return error;

  return 'An unexpected error occurred';
};
